import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Breadcrumb from "components/LayoutFront/Breadcrumb";
import { templatesWithXlBreakpoint } from "components/LayoutFront/Wrapper";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

const templateBannerStyled = ({ theme, breakpoint }) => ({
  pb: 4,
  mb: 2,
  minHeight: { xs: "124px", md: "156px" },
  width: "100%",
  bgcolor: "secondary.light",
  "& h1": {
    mb: 2,
  },
  " .fr-container": {
    maxWidth: `${theme.breakpoints.values[breakpoint]}px`,
    pl: { lg: 0 },
  },
});

const TemplateBanner = (props) => {
  const { children, bo = false, template } = props;

  const breakpoint = useMemo(() => (templatesWithXlBreakpoint.includes(template) ? "xl" : "lg"), [template]);

  return (
    <Box sx={(theme) => templateBannerStyled({ theme, breakpoint })}>
      <Box className="fr-container">
        <Breadcrumb bo={bo} />
        <Stack sx={{ "& *": { textAlign: "left" } }}>{children}</Stack>
      </Box>
    </Box>
  );
};

TemplateBanner.propTypes = {
  children: PropTypes.node.isRequired,
  bo: PropTypes.bool,
  template: PropTypes.string,
};

export default TemplateBanner;
